import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';

export function AppShell() {
  // Local component state only, per the explicit "no Redux/Zustand"
  // constraint - this is UI-only state (is the sidebar collapsed),
  // exactly the kind of thing the existing state-management approach
  // already said belongs in plain useState, not a global store.
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="app-shell">
      <Topbar onToggleSidebar={() => setCollapsed((c) => !c)} />
      <div className="app-body">
        <Sidebar collapsed={collapsed} />
        <main className="app-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
